import styled, { keyframes } from 'styled-components';
import { Layout } from 'antd';
import { Theme } from '@shared/theme';

const pulse = keyframes`
    0% { opacity: 1; }
    50% { opacity: 0.3; }
    100% { opacity: 1; }
`;

export const StyledSider = styled(Layout.Sider).attrs({ theme: 'dark' })`
  overflow: auto;
  height: 100vh;
  position: sticky;
  top: 0;
  left: 0;
  box-shadow:
    0 1px 2px -2px rgba(0, 0, 0, 0.16),
    0 3px 6px 0 rgba(0, 0, 0, 0.12),
    0 5px 12px 4px rgba(0, 0, 0, 0.09);
  background: ${Theme.colors.sidebarBg} !important;

  .ant-layout-sider-children {
    background: ${Theme.colors.sidebarBg};
  }

  .ant-menu.ant-menu-dark {
    background: ${Theme.colors.menuBg};
  }

  .ant-menu-dark .ant-menu-item-group-title {
    color: rgba(255, 255, 255, 0.45);
  }

  .ant-menu-dark .ant-menu-item:hover,
  .ant-menu-dark .ant-menu-item-active {
    border-radius: 0;
    background-color: ${Theme.colors.menuHoverItemBg} !important;
  }

  .ant-menu-dark.ant-menu-inline .ant-menu-item-selected,
  .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
    border-radius: 0;
    background-color: ${Theme.colors.menuActiveItemBg} !important;
  }

  .ant-menu-dark .ant-menu-submenu-title {
    border-radius: 0;
  }

  .ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title,
  .ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title {
    border-radius: 0;
  }

  .ant-menu-dark .ant-menu-sub {
    background: ${Theme.colors.menuSubBg};
  }

  .ant-menu-inline-collapsed {
    width: 46px;

    .ant-menu-item-group-title {
      display: none;
    }

    .ant-menu-item {
      padding: 0 15px;
    }
  }

  z-index: 1000;
`;

export const Brand = styled.div`
  height: 46px;
  line-height: 46px;
  text-align: center;
  background-color: ${Theme.colors.sidebarBg};

  img {
    height: 24px;
  }
`;

// Deliberately low-contrast against sidebarBg — readable only on a close look
export const CounterUpdatedAt = styled.div`
  padding: 8px 4px 12px;
  text-align: center;
  font-size: 10px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.18);
  user-select: none;
`;

export const InspectionBadge = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  min-width: 8px;
  background-color: #ff4d4f;
  border-radius: 50%;
  margin-left: 8px;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;
